<div class="service-interruption-banner" role="alert" aria-live="assertive">
  <span class="icon caution" aria-label="Caution">
    <ngx-axs-icon axsType="warningSolid" [axsWidth]="32"></ngx-axs-icon>
  </span>
  <div class="banner-content">
    <ng-content></ng-content>
    <span>{{ message }}</span>
  </div>
</div>